/**
 * Auto-generated by scripts/generate-drizzle-schema.mjs
 * Regenerate with: make generate-schema
 */

import { DrizzleAppSchema, type PowerSyncSQLiteDatabase } from "@powersync/drizzle-driver";
import { index, integer, sqliteTable, text } from "drizzle-orm/sqlite-core";
import type { InferInsertModel, InferSelectModel } from "drizzle-orm";

// ⚡ Destacados propios del usuario.
export const bible_highlight = sqliteTable(
  "bible_highlight",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    color: text("color"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** Filtro de destacados propios del usuario */
    index("bible_highlight_by_user").on(table.user_id),
  ],
);

// Relación de etiquetas/tags para cada destacado.
export const bible_highlight_tag = sqliteTable(
  "bible_highlight_tag",
  {
    id: text("id").primaryKey(),
    highlight_id: text("highlight_id"),
    tag: text("tag"),
  },
  (table) => [
    /** Búsqueda de etiquetas por ID de destacado */
    index("bible_highlight_tag_by_highlight").on(table.highlight_id),
    /** Búsqueda de destacados por etiqueta */
    index("bible_highlight_tag_by_tag").on(table.tag),
  ],
);

// Relación de versículos para cada destacado.
export const bible_highlight_verse = sqliteTable(
  "bible_highlight_verse",
  {
    id: text("id").primaryKey(),
    highlight_id: text("highlight_id"),
    version: text("version"),
    book: integer("book"),
    chapter: integer("chapter"),
    verse: integer("verse"),
  },
  (table) => [
    /** Búsqueda por ID de destacado */
    index("bible_highlight_verse_by_highlight").on(table.highlight_id),
    /** Búsqueda/renderizado rápido de versículos destacados */
    index("bible_highlight_verse_by_coordinates").on(
      table.version,
      table.book,
      table.chapter,
      table.verse,
    ),
  ],
);

// ⚡ Notas personales propias del usuario.
export const bible_note = sqliteTable(
  "bible_note",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    text_content: text("text_content"),
    color: text("color"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** Filtro de notas propias del usuario */
    index("bible_note_by_user").on(table.user_id),
  ],
);

// Relación de etiquetas/tags para cada nota.
export const bible_note_tag = sqliteTable(
  "bible_note_tag",
  {
    id: text("id").primaryKey(),
    note_id: text("note_id"),
    tag: text("tag"),
  },
  (table) => [
    /** Búsqueda de etiquetas por ID de nota */
    index("bible_note_tag_by_note").on(table.note_id),
    /** Búsqueda de notas por etiqueta */
    index("bible_note_tag_by_tag").on(table.tag),
  ],
);

// Relación de versículos para cada nota.
export const bible_note_verse = sqliteTable(
  "bible_note_verse",
  {
    id: text("id").primaryKey(),
    note_id: text("note_id"),
    version: text("version"),
    book: integer("book"),
    chapter: integer("chapter"),
    verse: integer("verse"),
  },
  (table) => [
    /** Búsqueda por ID de nota */
    index("bible_note_verse_by_note").on(table.note_id),
    /** Búsqueda/renderizado rápido de versículos asociados a notas */
    index("bible_note_verse_by_coordinates").on(
      table.version,
      table.book,
      table.chapter,
      table.verse,
    ),
  ],
);

// ⚡ Subrayados individuales a nivel de versículo.
export const bible_verse_highlight = sqliteTable(
  "bible_verse_highlight",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    version: text("version"),
    book: integer("book"),
    chapter: integer("chapter"),
    verse: integer("verse"),
    color: text("color"),
    origin_id: text("origin_id"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** Subrayados individuales por usuario */
    index("bible_verse_highlight_by_user").on(table.user_id),
    /** Búsqueda rápida de subrayados por coordenadas */
    index("bible_verse_highlight_by_coordinates").on(
      table.version,
      table.book,
      table.chapter,
      table.verse,
    ),
  ],
);

// ⚡ Marcadores/favoritos propios del usuario a nivel de versículo.
export const bible_bookmark = sqliteTable(
  "bible_bookmark",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    version: text("version"),
    book: integer("book"),
    chapter: integer("chapter"),
    verse: integer("verse"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** Marcadores propios del usuario */
    index("bible_bookmark_by_user").on(table.user_id),
    /** Búsqueda rápida de marcadores por coordenadas */
    index("bible_bookmark_by_coordinates").on(
      table.version,
      table.book,
      table.chapter,
      table.verse,
    ),
  ],
);

// ⚡ Progreso de planes de lectura: un registro por día completado de un plan.
// Las plantillas de plan son ESTÁTICAS en el cliente (`plan_id` = slug estable);
// solo el progreso del usuario se persiste y sincroniza (privado por `user_id`).
export const bible_reading_progress = sqliteTable(
  "bible_reading_progress",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    plan_id: text("plan_id"),
    day: integer("day"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** Progreso propio del usuario */
    index("bible_reading_progress_by_user").on(table.user_id),
    /** Días completados de un plan concreto */
    index("bible_reading_progress_by_plan").on(table.user_id, table.plan_id, table.day),
  ],
);

// ⚡ Texto bíblico para el lector OFFLINE (catálogo global, sembrado localmente).
export const bible_verse_content = sqliteTable(
  "bible_verse_content",
  {
    id: text("id").primaryKey(),
    version: text("version"),
    book: integer("book"),
    chapter: integer("chapter"),
    verse: integer("verse"),
    text: text("text"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** Renderizado del lector offline: versículos de un capítulo */
    index("bible_verse_content_by_coordinates").on(
      table.version,
      table.book,
      table.chapter,
      table.verse,
    ),
  ],
);

// ⚡ Léxico Strong para la CONCORDANCIA offline (catálogo global, sembrado localmente).
// `code` es el número Strong canónico (p. ej. "H7225", "G3056"). Catálogo de SOLO
// LECTURA: se siembra localmente (dominio público) y se marca `localOnly` para que
// no entre en la cola de subida de PowerSync.
export const strong_entry = sqliteTable(
  "strong_entry",
  {
    id: text("id").primaryKey(),
    code: text("code"),
    lemma: text("lemma"),
    transliteration: text("transliteration"),
    pronunciation: text("pronunciation"),
    gloss: text("gloss"),
    definition: text("definition"),
    language: text("language"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** Búsqueda de la entrada Strong por su número canónico */
    index("strong_entry_by_code").on(table.code),
  ],
);

// Metadatos globales de versiones bíblicas.
export const bible_version = sqliteTable("bible_version", {
  id: text("id").primaryKey(),
  name: text("name"),
  abbr: text("abbr"),
  language_iso2: text("language_iso2"),
  language_iso3: text("language_iso3"),
  language_name_english: text("language_name_english"),
  language_name_native: text("language_name_native"),
  status: text("status"),
  source_info_url: text("source_info_url"),
  source_info_download_url: text("source_info_download_url"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

// Ficheros adjuntos a las versiones bíblicas.
export const bible_version_file = sqliteTable(
  "bible_version_file",
  {
    id: text("id").primaryKey(),
    bible_version_id: text("bible_version_id"),
    file_type: text("file_type"),
    original_name: text("original_name"),
    extension: text("extension"),
    relative_path: text("relative_path"),
    sha256: text("sha256"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** Búsqueda de ficheros de la versión bíblica */
    index("bible_version_file_by_bible_version").on(table.bible_version_id),
  ],
);

export const font_family = sqliteTable("font_family", {
  id: text("id").primaryKey(),
  family: text("family"),
  name: text("name"),
  category: text("category"),
  is_active: integer("is_active"),
  sort_order: integer("sort_order"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const font_variant = sqliteTable("font_variant", {
  id: text("id").primaryKey(),
  font_family_id: text("font_family_id"),
  weight: text("weight"),
  url: text("url"),
  created_at: text("created_at"),
  attachment_id: text("attachment_id"),
});

// ⚡ Tabla con índice en user_id para acelerar getHasLocalDataQuery.

// Dataset pequeño por usuario — índices no necesarios por ahora.
export const member = sqliteTable("member", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  user_id: text("user_id"),
  role: text("role"),
  created_at: text("created_at"),
});

// Dataset pequeño — índices no necesarios por ahora.
export const organization = sqliteTable("organization", {
  id: text("id").primaryKey(),
  name: text("name"),
  slug: text("slug"),
  logo: text("logo"),
  metadata: text("metadata"),
  created_at: text("created_at"),
});

// Sesiones activas del usuario — dataset pequeño, sin índices.
export const session = sqliteTable("session", {
  id: text("id").primaryKey(),
  expires_at: text("expires_at"),
  token: text("token"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  ip_address: text("ip_address"),
  user_agent: text("user_agent"),
  user_id: text("user_id"),
  active_organization_id: text("active_organization_id"),
});

// Dataset global pequeño (~20 temas) — índices no necesarios.
export const themes = sqliteTable("themes", {
  id: text("id").primaryKey(),
  name: text("name"),
  background: text("background"),
  surface: text("surface"),
  accent: text("accent"),
  glow_colors: text("glow_colors"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  is_dark: integer("is_dark"),
  foreground: text("foreground"),
  field_background: text("field_background"),
  danger: text("danger"),
  success: text("success"),
  warning: text("warning"),
  muted: text("muted"),
  pattern_type: text("pattern_type"),
  pattern_opacity: integer("pattern_opacity"),
  pair_id: text("pair_id"),
  font_normal: text("font_normal"),
  font_medium: text("font_medium"),
  font_semibold: text("font_semibold"),
  font_bold: text("font_bold"),
  radius: text("radius"),
  surface_foreground: text("surface_foreground"),
  surface_secondary: text("surface_secondary"),
  surface_secondary_foreground: text("surface_secondary_foreground"),
  surface_tertiary: text("surface_tertiary"),
  surface_tertiary_foreground: text("surface_tertiary_foreground"),
  overlay: text("overlay"),
  overlay_foreground: text("overlay_foreground"),
  default: text("default"),
  default_foreground: text("default_foreground"),
  accent_foreground: text("accent_foreground"),
  field_foreground: text("field_foreground"),
  field_placeholder: text("field_placeholder"),
  field_border: text("field_border"),
  danger_foreground: text("danger_foreground"),
  success_foreground: text("success_foreground"),
  warning_foreground: text("warning_foreground"),
  segment: text("segment"),
  segment_foreground: text("segment_foreground"),
  border: text("border"),
  focus: text("focus"),
  link: text("link"),
  surface_shadow: text("surface_shadow"),
  overlay_shadow: text("overlay_shadow"),
  field_shadow: text("field_shadow"),
  muted_foreground: text("muted_foreground"),
  divider: text("divider"),
  glass_background: text("glass_background"),
  glass_border: text("glass_border"),
  glass_highlight: text("glass_highlight"),
  is_active: integer("is_active"),
  sort_order: integer("sort_order"),
});

// ⚡ Tabla más grande (~4500+ filas). Los índices aquí tienen el mayor impacto.

// Solo 1 fila por usuario — índices no necesarios.
export const user = sqliteTable("user", {
  id: text("id").primaryKey(),
  name: text("name"),
  email: text("email"),
  email_verified: integer("email_verified"),
  image: text("image"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  locale: text("locale"),
  global_theme_id: text("global_theme_id"),
  is_blur: integer("is_blur"),
  font_family: text("font_family"),
  follow_device_theme: integer("follow_device_theme"),
  role: text("role"),
  banned: integer("banned"),
  ban_reason: text("ban_reason"),
  ban_expires: text("ban_expires"),
  two_factor_enabled: integer("two_factor_enabled"),
  two_factor_secret: text("two_factor_secret"),
  two_factor_backup_codes: text("two_factor_backup_codes"),
});

export const drizzleSchema = {
  bible_bookmark,
  bible_reading_progress,
  bible_highlight,
  bible_highlight_tag,
  bible_highlight_verse,
  bible_note,
  bible_note_tag,
  bible_note_verse,
  bible_verse_content,
  bible_verse_highlight,
  bible_version,
  bible_version_file,
  strong_entry,
  font_family,
  font_variant,
  member,
  organization,
  session,
  themes,
  user,
};

// `bible_verse_content` es un catálogo de SOLO LECTURA que el cliente siembra
// localmente (texto bíblico de dominio público) para que el lector funcione
// offline. Se marca `localOnly` para que esas escrituras NO entren en la cola de
// subida de PowerSync (ps_crud) — así no disparan el diálogo "Keep local data?"
// ni intentan sincronizar de vuelta el catálogo sembrado.
// NOTA: tweak manual sobre la salida del generador (scripts/generate-drizzle-schema.mjs).
export const AppSchema = new DrizzleAppSchema({
  ...drizzleSchema,
  bible_verse_content: { tableDefinition: bible_verse_content, options: { localOnly: true } },
  strong_entry: { tableDefinition: strong_entry, options: { localOnly: true } },
});

export type Database = (typeof AppSchema)["types"];

/**
 * Type helper for the Drizzle database instance wrapped with PowerSync.
 */
export type PowerSyncDrizzleDB = PowerSyncSQLiteDatabase<typeof drizzleSchema>;

export const USER_DATA_TABLES = [
  "bible_bookmark",
  "bible_highlight",
  "bible_note",
  "bible_reading_progress",
  "bible_verse_highlight",
] as const;

export type BibleBookmark = InferSelectModel<typeof bible_bookmark>;
export type BibleBookmarkInsert = InferInsertModel<typeof bible_bookmark>;
export type BibleBookmarkRecord = BibleBookmark;
export type BibleReadingProgress = InferSelectModel<typeof bible_reading_progress>;
export type BibleReadingProgressInsert = InferInsertModel<typeof bible_reading_progress>;
export type BibleReadingProgressRecord = BibleReadingProgress;
export type BibleHighlight = InferSelectModel<typeof bible_highlight>;
export type BibleHighlightInsert = InferInsertModel<typeof bible_highlight>;
export type BibleHighlightRecord = BibleHighlight;
export type BibleHighlightTag = InferSelectModel<typeof bible_highlight_tag>;
export type BibleHighlightTagInsert = InferInsertModel<typeof bible_highlight_tag>;
export type BibleHighlightTagRecord = BibleHighlightTag;
export type BibleHighlightVerse = InferSelectModel<typeof bible_highlight_verse>;
export type BibleHighlightVerseInsert = InferInsertModel<typeof bible_highlight_verse>;
export type BibleHighlightVerseRecord = BibleHighlightVerse;
export type BibleNote = InferSelectModel<typeof bible_note>;
export type BibleNoteInsert = InferInsertModel<typeof bible_note>;
export type BibleNoteRecord = BibleNote;
export type BibleNoteTag = InferSelectModel<typeof bible_note_tag>;
export type BibleNoteTagInsert = InferInsertModel<typeof bible_note_tag>;
export type BibleNoteTagRecord = BibleNoteTag;
export type BibleNoteVerse = InferSelectModel<typeof bible_note_verse>;
export type BibleNoteVerseInsert = InferInsertModel<typeof bible_note_verse>;
export type BibleNoteVerseRecord = BibleNoteVerse;
export type BibleVerseContent = InferSelectModel<typeof bible_verse_content>;
export type BibleVerseContentInsert = InferInsertModel<typeof bible_verse_content>;
export type BibleVerseContentRecord = BibleVerseContent;
export type BibleVerseHighlight = InferSelectModel<typeof bible_verse_highlight>;
export type BibleVerseHighlightInsert = InferInsertModel<typeof bible_verse_highlight>;
export type BibleVerseHighlightRecord = BibleVerseHighlight;
export type BibleVersion = InferSelectModel<typeof bible_version>;
export type BibleVersionInsert = InferInsertModel<typeof bible_version>;
export type BibleVersionRecord = BibleVersion;
export type BibleVersionFile = InferSelectModel<typeof bible_version_file>;
export type BibleVersionFileInsert = InferInsertModel<typeof bible_version_file>;
export type BibleVersionFileRecord = BibleVersionFile;
export type StrongEntry = InferSelectModel<typeof strong_entry>;
export type StrongEntryInsert = InferInsertModel<typeof strong_entry>;
export type StrongEntryRecord = StrongEntry;
export type FontFamily = InferSelectModel<typeof font_family>;
export type FontFamilyInsert = InferInsertModel<typeof font_family>;
export type FontFamilyRecord = FontFamily;
export type FontVariant = InferSelectModel<typeof font_variant>;
export type FontVariantInsert = InferInsertModel<typeof font_variant>;
export type FontVariantRecord = FontVariant;
export type Member = InferSelectModel<typeof member>;
export type MemberInsert = InferInsertModel<typeof member>;
export type MemberRecord = Member;
export type Organization = InferSelectModel<typeof organization>;
export type OrganizationInsert = InferInsertModel<typeof organization>;
export type OrganizationRecord = Organization;
export type Session = InferSelectModel<typeof session>;
export type SessionInsert = InferInsertModel<typeof session>;
export type SessionRecord = Session;
export type Themes = InferSelectModel<typeof themes>;
export type ThemesInsert = InferInsertModel<typeof themes>;
export type ThemesRecord = Themes;
export type User = InferSelectModel<typeof user>;
export type UserInsert = InferInsertModel<typeof user>;
export type UserRecord = User;
